
import moment from 'moment';
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';


const StyledDatetimeActions = styled.div`
  white-space: nowrap;
  
  .MuiButton-containedSizeSmall {
    padding: 4px 4px;
  }
`;


export class DatetimeActions extends Component {

  static propTypes = {
    roundingMinutes: PropTypes.number
  };

  static defaultProps = {
    roundingMinutes: 60
  };

  static format = 'YYYY-MM-DDTHH:mm:ssZ';

  handleToday = () => {
    const { onChange } = this.props;
    onChange(moment().startOf('day').format(DatetimeActions.format));
  };

  handleNow = () => {
    const { onChange, roundingMinutes } = this.props;
    const now = moment();
    const remainder = roundingMinutes - now.minute() % roundingMinutes;
    onChange(moment(now).add('minutes', remainder).format(DatetimeActions.format));
  };

  handleEndDay = () => {
    const { onChange } = this.props;
    onChange(moment().endOf('day').format(DatetimeActions.format));
  };

  handleChangeTime = (hour, minute) => {
    const { onChange, value } = this.props;
    if (value && moment(value).isValid()) {
      let datetime = moment(value);
      datetime.hour(hour);
      datetime.minute(minute);
      onChange(datetime.format(DatetimeActions.format));
    }
    else {
      let datetime = moment();
      datetime.hour(hour);
      datetime.minute(minute);
      onChange(datetime.format(DatetimeActions.format));
    }
  };

  handleAdd = (minutes) => {
    const { onChange, value } = this.props;
    if (value && moment(value).isValid()) {
      let datetime = moment(value);
      datetime.add('minutes', minutes);
      onChange(datetime.format(DatetimeActions.format));
    }
  };

  handleSubtract = (minutes) => {
    const { onChange, value } = this.props;
    if (value && moment(value).isValid()) {
      let datetime = moment(value);
      datetime.subtract('minutes', minutes);
      onChange(datetime.format(DatetimeActions.format));
    }
  };

  render() {
    const { value, onChange, roundingMinutes, className, ...otherProps } = this.props;
    return (
      <StyledDatetimeActions className={className}>
        <ButtonGroup disableElevation size={'small'} variant="contained" {...otherProps}>
          <Button onClick={() => this.handleNow()}>Сейчас</Button>
          {this.props.children}
        </ButtonGroup>

        <ButtonGroup disableElevation size={'small'} variant="contained" className={'ml-9'}>
          <Button onClick={() => this.handleSubtract(roundingMinutes)}>- {roundingMinutes}</Button>
          <Button onClick={() => this.handleAdd(roundingMinutes)}>+ {roundingMinutes}</Button>
        </ButtonGroup>

        <ButtonGroup disableElevation size={'small'} variant="contained" className={'ml-9'}>
          <Button onClick={() => this.handleChangeTime(0, 0)}>00:00</Button>
          <Button onClick={() => this.handleChangeTime(6, 0)}>06:00</Button>
          <Button onClick={() => this.handleChangeTime(12, 0)}>12:00</Button>
          <Button onClick={() => this.handleChangeTime(15, 0)}>15:00</Button>
          <Button onClick={() => this.handleChangeTime(18, 0)}>18:00</Button>
          <Button onClick={() => this.handleChangeTime(23, 0)}>23:00</Button>
        </ButtonGroup>
      </StyledDatetimeActions>
    )
  }
}
